import { Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../../TemporalEntity';

export default class ContactType extends TemporalEntity {
    static typeName = "ContactType";

    constructor() {
        super();
        this.makeObservable();
    }

    public contactTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    public contactTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.contactTypeName) {
            return "New contact type";
        } else {
            return this.contactTypeName;
        }
    }
}